import { ClassTypename } from "@zebrasoft/core-ui";
import { ECSLogDecorator } from "@zebrasoft/watson-browser";
import { Ecs } from "@zebrasoft/watson-browser/dist/Model";
import { AuthenticationStore } from "features/authentication";
import { cityline } from "features/cityline";
import { SettingsStore } from "features/settings/SettingsStore";
import { IVersion } from "lib/Model";

@ClassTypename("LinkstacksLogDecorator")
export class LinkstacksLogDecorator extends ECSLogDecorator {
    async decorate(entry: Ecs) {
        entry.metadata = entry.metadata || {};

        const user = await AuthenticationStore.instance.currentUserNoFetch();
        entry.metadata._userId = user?.userId;
        entry.metadata.clientVersion = SettingsStore.instance.version.toString();

        try {
            const version = await cityline.getFrame<IVersion>("version");
            entry.metadata.serverVersion = version?.textual;
        } catch {
            entry.metadata.serverVersion = undefined;
        }

        entry.metadata.navigator = {
            appName: window.navigator.appName,
            appCodeName: window.navigator.appCodeName,
            appVersion: window.navigator.appVersion,
            cookieEnabled: window.navigator.cookieEnabled,
            languages: window.navigator.languages,
            oscpu: (<any>window.navigator).oscpu,
            platform: window.navigator.platform,
            product: window.navigator.product,
            webdriver: window.navigator.webdriver
        };
    }
}
